<template>
  <div class="rb-applied-filters" v-if="appliedFiltersDisplay.length">
    <div
      class="rb-applied-filter"
      v-for="(appliedFilter, indexAppliedFilter) in appliedFiltersDisplay"
      :key="`applied-filter-${indexAppliedFilter}`"
    >
      <span
        >{{ filterLabel(appliedFilter) }}:
        {{ filterValue(appliedFilter) }}</span
      >
      <button
        aria-label="Remove Filter"
        @click.prevent="removeFilter(appliedFilter)"
      >
        <icon-close />
      </button>
    </div>
  </div>
</template>
<script>
/**
 * Widget.
 * Displays a list of Applied Filters. It subscribes to filter events and emits filters removal events
 *
 * @props
 * appliedFilters: Array
 *
 * @emits
 * rb-display-update
 *
 * @implements
 * CommMixin
 */
import CommMixin from "@/mixins/CommMixin";
import { formatMoney } from "../lib";
import IconClose from "@/components/icons/IconClose";
export default {
  mixins: [CommMixin],
  components: { IconClose },
  props: {
    appliedFilters: {
      type: Array,
    },
  },
  computed: {
    appliedFiltersDisplay: function () {
      return this.appliedFilters.filter(
        (appliedFilter) => appliedFilter.type !== "shape"
      );
    },
  },
  watch: {
    appliedFiltersDisplay: function () {
      this.$emit("rb-display-update");
    },
  },
  methods: {
    removeFilter: function (filter) {
      this.broadcast("rb-remove-filters", filter);
    },
    filterLabel: function (appliedFilter) {
      if (appliedFilter.type === "retail_price") {
        return "price";
      }
      return appliedFilter.type;
    },
    filterValue: function (appliedFilter) {
      if (appliedFilter.type === "retail_price") {
        return `$${formatMoney(appliedFilter.min)}-$${formatMoney(
          appliedFilter.max
        )}`;
      }
      if (appliedFilter.type === "carats") {
        return `${appliedFilter.min.toFixed(5)}-${appliedFilter.max.toFixed(
          5
        )}`;
      }
      return appliedFilter.title;
    },
  },
};
</script>
